import { useEffect } from 'react';

export default function PageMetadata({ pathname, page }) {
  const title = pathname === '/about' ? 'About Us | Trillium Paws' : page ? `${page.title} | Trillium Paws` : 'Trillium Paws | Dog Supplements & Pet Care';
  const description = pathname === '/about'
    ? 'Meet Trillium Paws and discover our approach to dog wellness: thoughtful nutrition, soft chews, and everyday pet care for more happy moments together.'
    : page?.description || 'Discover Trillium Paws dog supplements, soft chews, and pet care essentials. Thoughtful nutrition and everyday care for a happier life together.';

  useEffect(() => {
    document.title = title;
    const metadata = [
      ['name', 'description', description],
      ['property', 'og:title', title],
      ['property', 'og:description', description],
      ['name', 'twitter:title', title],
      ['name', 'twitter:description', description],
    ];
    metadata.forEach(([attribute, key, content]) => {
      let tag = document.head.querySelector(`meta[${attribute}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attribute, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    });
  }, [title, description]);

  return null;
}
